// extracted by mini-css-extract-plugin
module.exports = {"adjustSpacingInDesktop":"UserProfile_adjust-spacing-in-desktop__3O3aH"};